import React, { type FC } from "react"
import { Container } from "@components/styles"
import Image from "@components/Image"
import { CardsThreeColumnsProps } from "./types"
import {
    Card,
    CardIcon,
    CardsThreeColumnsWrapper,
    CardsWrapper,
    Content,
    StyledLink,
    Text,
    Title
} from "./styles"

const CardsThreeColumns: FC<CardsThreeColumnsProps> = ({
    content,
    cards
}) => {
    return <Container>
        <CardsThreeColumnsWrapper>
            <Content dangerouslySetInnerHTML={{ __html: content }} />
            <CardsWrapper>
                {cards?.map((c) => (
                    <Card>
                        <CardIcon>
                            {c.icon && <Image image={c.icon} />}
                        </CardIcon>
                        <Title>{c.title}</Title>
                        <Text>{c.text}</Text>
                        <StyledLink
                            href={c.uri}
                            target="_blank"
                            rel="noreferrer"
                        >
                            Lees meer
                        </StyledLink>
                    </Card>
                ))}
            </CardsWrapper>
        </CardsThreeColumnsWrapper>
    </Container>
}

export default CardsThreeColumns
